import * as THREE from 'three';
import { CONFIG } from '../config.js';

const C = CONFIG.camera;
const _fwd = new THREE.Vector3();
const _target = new THREE.Vector3();
const REDUCED_MOTION = globalThis.matchMedia?.('(prefers-reduced-motion: reduce)').matches ?? false;

/** Cámara en tercera persona que gira suavemente tras el jugador en las curvas. */
export class CameraRig {
  constructor(camera) {
    this.camera = camera;
    this.yaw = 0;
    this.height = 0;
    this.anchor = new THREE.Vector3();
    this.shakeAmount = 0;
  }

  /** Sacudida breve (tropiezos, choques). amount en metros. */
  shake(amount) {
    if (REDUCED_MOTION) return; // ajuste del sistema «reducir movimiento»
    this.shakeAmount = Math.max(this.shakeAmount, amount);
  }

  reset(player) {
    this.update(player, 0);
  }

  update(player, dt) {
    const cam = this.camera;

    // Al caer al vacío la cámara se queda quieta y mira cómo cae.
    if (player.state === 'falling') {
      const p = player.position;
      cam.lookAt(_target.set(p.x, p.y + 1, p.z));
      return;
    }

    const snap = dt <= 0;
    const k = (rate) => (snap ? 1 : 1 - Math.exp(-rate * dt));
    this.yaw += (player.yaw - this.yaw) * k(C.yawSmoothing);
    // La cámara solo acompaña la mitad del salto para que no maree.
    this.height += (player.y * 0.5 - this.height) * k(C.heightSmoothing);
    // Sigue solo parte del movimiento lateral y lo suaviza (también absorbe el ajuste al girar).
    // El suavizado crece con la velocidad para que la cámara no se quede atrás (p. ej. en el sprint).
    this.anchor.lerp(player.cameraAnchor, k(C.positionSmoothing * Math.max(1, player.speed / CONFIG.speed.base)));

    const a = this.anchor;
    _fwd.set(-Math.sin(this.yaw), 0, -Math.cos(this.yaw));
    cam.position.set(a.x, this.height + C.height, a.z).addScaledVector(_fwd, -C.distance);
    _target.set(a.x, this.height + C.lookHeight, a.z).addScaledVector(_fwd, C.lookAhead);
    cam.lookAt(_target);

    if (this.shakeAmount > 0.002) {
      const a = this.shakeAmount;
      cam.position.x += (Math.random() - 0.5) * a;
      cam.position.y += (Math.random() - 0.5) * a;
      cam.rotation.z += (Math.random() - 0.5) * a * 0.15;
      this.shakeAmount *= Math.exp(-7 * Math.max(dt, 0.016));
    }
  }
}
